export class ExtendedAttributesModel {
    name: string;
    value: any;
}